<template>
  <div class="c-tab-availability">
    <div class="o-grid o-grid--gutter-large">
      <div class="o-grid__group">
        <div class="o-grid__item  o-grid__item--12">
          <CallCenterAEDavailability
            @stateChange="
              isEditing = $event;
              resetKey += 1;
            "
          ></CallCenterAEDavailability>
        </div>
        <div
          v-if="availabilityAll.availability === 'OpeningHours'"
          class="o-grid__item  o-grid__item--6"
        >
          <div class="o-grid o-grid--gutter-normal">
            <div class="o-grid__group">
              <div class="o-grid__item o-grid__item--12">
                <CallCenterAEDopeningHours
                  :key="resetKey"
                  :isEditing="isEditing"
                ></CallCenterAEDopeningHours>
              </div>
              <div class="o-grid__item o-grid__item--12">
                <CallCenterAEDspecialPeriods
                  :key="resetKey"
                  :isEditing="isEditing"
                ></CallCenterAEDspecialPeriods>
              </div>
              <div class="o-grid__item o-grid__item--12">
                <CallCenterAEDclosedDays
                  :key="resetKey"
                  :isEditing="isEditing"
                ></CallCenterAEDclosedDays>
              </div>
            </div>
          </div>
        </div>
        <div
          v-if="availabilityAll.availability === 'OpeningHours'"
          class="o-grid__item  o-grid__item--6"
        >
          <CallCenterAEDpublicHolidays
            :key="resetKey"
            :isEditing="isEditing"
          ></CallCenterAEDpublicHolidays>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CallCenterAEDavailability from "@/components/AED/aed-availability.vue";
import CallCenterAEDopeningHours from "@/components/AED/aed-openingHours.vue";
import CallCenterAEDpublicHolidays from "@/components/AED/aed-publicHolidays.vue";
import CallCenterAEDspecialPeriods from "@/components/AED/aed-specialPeriods.vue";
import CallCenterAEDclosedDays from "@/components/AED/aed-closedDays.vue";
import { mapState } from "vuex";
export default {
  name: "c-tab-availability",
  data() {
    return {
      isEditing: false,
      resetKey: 0
    };
  },
  components: {
    CallCenterAEDavailability,
    CallCenterAEDopeningHours,
    CallCenterAEDpublicHolidays,
    CallCenterAEDspecialPeriods,
    CallCenterAEDclosedDays
  },
  computed: {
    ...mapState("availability", {
      availabilityAll: "all"
    })
  },
  created() {
    this.$store.dispatch("availability/setAvailabilityStateToInitial");
  }
};
</script>
<style lang="scss">
@import "~svg-spritemap-webpack-plugin/sprites.scss";
.c-tab-availability {
  $dateInput: ".vs__search";
  $timeInput: ".vtimeselector__input";
  .v-select {
    width: 100%;

    &--open {
      .vs__selected {
        height: 100%;
      }
    }

    &.vs {
      &--open {
        .vs__selected {
          opacity: 0.4;
        }
      }
      &--searching {
        .vs__selected {
          display: none;
        }
      }
      &--disabled {
        .vs__dropdown-toggle {
          background: transparent;
        }
        .vs__actions {
          display: none;
        }
        .vs__selected {
          cursor: default;
        }
      }
    }

    .vs {
      &__search,
      &__search:focus {
        height: toRem(30px);
        vertical-align: middle;
        border: 1px solid transparent;
        flex: 1 1 100%;
        width: 100%;
        @include setStyles("15", $s-typography-sizes);
        line-height: 19px;
        padding: 0 10px;
        margin: 0;
        border-radius: 3px;
        &::-ms-clear {
          display: none;
          width: 0;
          height: 0;
        }
        &::-ms-reveal {
          display: none;
          width: 0;
          height: 0;
        }

        /* clears the 'X' from Chrome */
        &::-webkit-search-decoration,
        &::-webkit-search-cancel-button,
        &::-webkit-search-results-button,
        &::-webkit-search-results-decoration {
          display: none;
        }

        &:disabled {
          background: transparent;
        }
      }
      &__selected-options {
        padding: 0;
      }
      &__selected {
        position: absolute;
        margin: 0;
        border: none;
        height: 100%;
        padding: 5px 25px 5px 10px;
        text-overflow: ellipsis;
        overflow: hidden;
        white-space: nowrap;
        display: block;
        width: 100%;
        @include setStyles("15", $s-typography-sizes);
        line-height: 19px;
      }

      &__dropdown-toggle {
        padding: 0;
        border: none;
      }
      &__dropdown-menu {
        margin: 1px 0;
      }
      &__dropdown-option {
        padding: 3px 10px;
        overflow: hidden;
        text-overflow: ellipsis;
      }
    }

    &.active {
      #{$dateInput} {
        border: 1px solid $s-cp-neutral-400;

        &:focus {
          outline: $s-cp-sup-focus auto 1px;
        }
      }
    }

    &.error {
      #{$dateInput} {
        border: 1px solid $s-cp-sup-red;
        color: $s-cp-sup-red;

        &:focus {
          outline: $s-cp-sup-red auto 1px;
        }
      }
    }
  }
  .vdp-datepicker {
    width: 125px;
    &__calendar-button {
      position: absolute;
      top: 50%;
      transform: translateY(-50%);
      right: 5px;
      pointer-events: none;
      + input {
        padding-right: 23px;
      }
    }
    .o-svg-icon {
      &--calendar {
        @include sprite("date");
        width: 18px;
        height: 18px;
        display: block;
      }
    }

    input {
      border: 1px solid $s-cp-neutral-400;
      border-radius: 3px;
      &:disabled {
        border: 1px solid transparent;
        background: transparent;
      }
    }
  }
  .o-label {
    min-height: toRem(30px);
    padding: 5px 0;
  }
}
</style>
